import React from 'react';
import classNames from 'classnames';
/**
 * Bronson Toggle component.
 * @see https://bronson.vwfs.io/default/components/detail/bronson-toggle.html
 * @constructor
 */
export function Toggle({ children, className, id, inputType = 'checkbox', name = 'toggle', onChange, onOff, textOther, testId, ...otherProps }) {
    const divClassNameList = classNames('c-toggle', {
        'c-toggle--on-off': onOff,
    }, className).trim();
    function renderIfToggleOnOff() {
        if (onOff) {
            return React.createElement("span", { className: "c-toggle__text" }, textOther);
        }
        return null;
    }
    return (React.createElement("div", { className: divClassNameList },
        React.createElement("label", { htmlFor: id },
            renderIfToggleOnOff(),
            React.createElement("input", { ...otherProps, onChange: onChange, "data-testid": testId, className: "c-toggle__input", type: inputType, id: id, name: name }),
            React.createElement("span", { className: "c-toggle__text" }, children))));
}
